import {
  always,
  compose,
  concat,
  converge,
  equals,
  identity,
  ifElse,
  join,
  prop,
  when,
} from "ramda";
import queryString from "query-string";

import { GetWindowLanguage } from "./storyHelpers";
import {
  HELP_CENTER_LOCALES_BY_KEY,
  LANGUAGES_BY_BASENAME,
} from "../constants/languages";
import { baseSiteUrl, cxApiParams, baseSsoUrl } from "../../config";

const getBasename = compose(
  ifElse(equals("en"), always(""), identity),
  GetWindowLanguage
);

const getExternalLocalizedUrl = converge(concat, [
  identity,
  compose(
    when(Boolean, concat('/')),
    getBasename
  )
])



const getExternalLocalizedLink = (path) =>
  concat(getExternalLocalizedUrl(baseSiteUrl), path);

const getLanguageByBasename = converge(prop, [
  getBasename,
  always(LANGUAGES_BY_BASENAME),
]);

const getLocalizedHelpCenterLink = () =>
  concat(
    "https://help.crunchyroll.com/hc/",
    HELP_CENTER_LOCALES_BY_KEY[getLanguageByBasename().key]
  );

const getSignInUrl = (redirect_path) =>
  concat(
    `${baseSsoUrl}/authorize?`,
    queryString.stringify({
      redirect_uri: `${baseSiteUrl}/callback`,
      response_type: "cookie",
      client_id: cxApiParams.accountAuthClientId,
      state:
        redirect_path ??
        join("", [
          window.location.pathname,
          window.location.search,
          window.location.hash,
        ]),
    })
  );

const getSignUpUrl = () =>
  `${getSignInUrl("/account/preferences")}&prompt=register`;

export {
  getLocalizedHelpCenterLink,
  getExternalLocalizedLink,
  getBasename,
  getSignInUrl,
  getSignUpUrl,
  getLanguageByBasename,
};
